export const HEX_COLOR_REGEX = /^#?[0-9a-fA-F]{6}$/;

export type HexColorParseResult = { status: "empty" } | { status: "invalid" } | { status: "valid"; value: string };

/**
 * Parses a raw hex-color input into a discriminated result rather than overloading
 * null/undefined/string on the return type: "empty" (the field was cleared), "invalid"
 * (non-empty but not a valid 6-digit hex -- caller should show an error and not persist), or
 * "valid" with the normalized, uppercased "#RRGGBB" string. Every caller must switch on
 * `status`, so a future call site can't silently mishandle the invalid case the way an
 * unchecked `=== undefined` comparison could.
 */
export const parseHexColor = (raw: string): HexColorParseResult => {
    const trimmed = raw.trim();
    if (trimmed === "") {
        return { status: "empty" };
    }
    if (!HEX_COLOR_REGEX.test(trimmed)) {
        return { status: "invalid" };
    }
    const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
    return { status: "valid", value: withHash.toUpperCase() };
};
